import React from 'react';
import { at } from 'lodash';
import { useField, Form, FormikProps, Formik } from 'formik';
import TextField from '@mui/material/TextField';

export default function InputNumeric(props: any) {
  const { errorText, ...rest } = props;
  const [field, meta] = useField(props);

  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');

    if (touched && error) {
      return error;
    }
    if (touched && props.required && (!field.value || field.value === '')) {
      return 'Campo requerido';
    }
  }

  return (
    <TextField
      error={Boolean(
        (meta.touched && meta.error) ||
        (meta.touched && props.required && (!field.value || field.value === ''))
      )}
      helperText={_renderHelperText()}
      type="number"
      {...field}
      {...rest}
    />
  );
}
